<div
  [class.ebo-dropdown--disabled]="disabled"
  [class.ebo-dropdown--error]="error"
  [class.ebo-dropdown--focused]="isFocused"
  [class.ebo-dropdown--open]="isOpen"
  class="ebo-dropdown"
>

  <!-- Label -->
  <label *ngIf="title" class="ebo-dropdown__label">
    {{ title }}
  </label>

  <!-- Dropdown Control -->
  <div (blur)="onBlur()"
       (click)="toggleDropdown()"
       [attr.aria-disabled]="disabled"
       [attr.aria-expanded]="isOpen"
       [attr.aria-label]="title"
       [attr.aria-required]="required"
       class="ebo-dropdown__control"
       role="combobox"
       tabindex="0">

    <span [class.ebo-dropdown__value--placeholder]="!selectedValue"
          class="ebo-dropdown__value">
      {{ getSelectedLabel() }}
    </span>

    <svg class="ebo-dropdown__arrow" fill="none" height="28" viewBox="0 0 28 28" width="28"
         xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.04165 14C9.04057 13.8136 9.07631 13.6287 9.14681 13.4561C9.21731 13.2835 9.32119 13.1265 9.45248 12.9942L16.5358 5.91084C16.6679 5.77875 16.8247 5.67397 16.9973 5.60248C17.1699 5.531 17.3549 5.49421 17.5417 5.49421C17.7285 5.49421 17.9134 5.531 18.086 5.60248C18.2586 5.67397 18.4154 5.77875 18.5475 5.91084C18.6796 6.04293 18.7844 6.19974 18.8558 6.37232C18.9273 6.5449 18.9641 6.72987 18.9641 6.91667C18.9641 7.10347 18.9273 7.28844 18.8558 7.46102C18.7844 7.6336 18.6796 7.79041 18.5475 7.9225L12.4558 14L18.5475 20.0775C18.8142 20.3443 18.9641 20.7061 18.9641 21.0833C18.9641 21.4606 18.8142 21.8224 18.5475 22.0892C18.2807 22.3559 17.9189 22.5058 17.5417 22.5058C17.1644 22.5058 16.8026 22.3559 16.5358 22.0892L9.45248 15.0058C9.32119 14.8735 9.21731 14.7165 9.14681 14.5439C9.07631 14.3713 9.04057 14.1864 9.04165 14Z"
        fill="#3B3B3A" />
    </svg>
  </div>

  <!-- Dropdown Options -->
  <div *ngIf="isOpen" class="ebo-dropdown__menu" role="listbox">
    <div (click)="selectOption(option)"
         *ngFor="let option of options; trackBy: trackByValue"
         [attr.aria-disabled]="option.disabled"
         [attr.aria-selected]="option.value === selectedValue"
         [class.ebo-dropdown__option--disabled]="option.disabled"
         [class.ebo-dropdown__option--selected]="option.value === selectedValue"
         class="ebo-dropdown__option"
         role="option">
      {{ option.label }}
    </div>

    <div *ngIf="options.length === 0" class="ebo-dropdown__empty">
      No options available
    </div>
  </div>

  <!-- Hint Text -->
  <span *ngIf="hint && !error" class="ebo-dropdown__hint">
    {{ hint }}
  </span>

  <!-- Error Text -->
  <span *ngIf="error" class="ebo-dropdown__error">
    {{ error }}
  </span>
</div>
